import { MouseEvent, useCallback, useContext } from "react";
import {
  useStore,
  getStraightPath,
  EdgeProps,
  EdgeLabelRenderer,
  useReactFlow,
} from "reactflow";
import { Button, Icon } from "semantic-ui-react";
import { getEdgeParams } from "../utils";
import { DrawingContext } from "../DrawingTool";

const edgeActiveColor = "var(--menuBarIconActive)";

function FloatingEdge(props: EdgeProps) {
  const { id, source, target, style, selected } = props;
  const { deleteElements } = useReactFlow();
  const { lockStatus } = useContext(DrawingContext);
  const sourceNode = useStore(
    useCallback((store) => store.nodeInternals.get(source), [source])
  );
  const targetNode = useStore(
    useCallback((store) => store.nodeInternals.get(target), [target])
  );

  const onDelete = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      deleteElements({ edges: [{ id }] });
    },
    [deleteElements, id]
  );

  if (!sourceNode || !targetNode) {
    return null;
  }
  const { sx, sy, tx, ty } = getEdgeParams(sourceNode, targetNode);

  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX: sx,
    sourceY: sy,
    targetX: tx,
    targetY: ty,
  });

  return (
    <>
      <path
        id={id}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={selected ? "url(#arrow_selected)" : "url(#arrow)"}
        style={{
          ...style,
          stroke: selected ? edgeActiveColor : style?.stroke,
        }}
      />
      {selected && !lockStatus && (
        <EdgeLabelRenderer>
          <div
            className="edge-delete-button nodrag nopan"
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: "all",
            }}
          >
            <Button icon size="mini" color="red" onClick={onDelete}>
              <Icon name="close" />
            </Button>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}

export default FloatingEdge;
